import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const Facility = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFacilities: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        type?: string;
      }
    >({
      query: ({ page, limit, search, type }) => ({
        url: `${END_POINTS.facility}?from=${page}&size=${limit}&search=${search}${type ? `&type=${type}` : ""}`,
        method: "GET",
      }),
    }),
    addFacility: builder.mutation<
      CommonResponseType,
      {
        name: string;
        image: string;
        type?: string;
      }
    >({
      query: (body) => ({
        url: END_POINTS.facility,
        method: "POST",
        body,
      }),
    }),
    getFacilityDetail: builder.query<
      CommonResponseType & {
        data: { facilityName: string };
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.facility}/${id}`,
        method: "GET",
      }),
    }),
    updateFacility: builder.mutation<
      CommonResponseType & { data: any },
      { body: { status?: boolean; categoryName?: string }; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.facility}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteFacility: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.facility}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetFacilitiesQuery,
  useAddFacilityMutation,
  useLazyGetFacilityDetailQuery,
  useUpdateFacilityMutation,
  useDeleteFacilityMutation
} = Facility;
